module.exports = __webpack_public_path__ + "static/oira-Logo-cecc3df7c59c89c4fa3d35f1b27b52a7.svg";